import { render, staticRenderFns } from "./ColorSelectPlaygroundModal.vue?vue&type=template&id=ddc2a8c6&lang=pug&"
import script from "./ColorSelectPlaygroundModal.vue?vue&type=script&lang=js&"
export * from "./ColorSelectPlaygroundModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports